export enum InstitutionOptionType {
  BASE = 'base',
  CHURN = 'churn',
  CONTRACT = 'contract',
  GTA = 'gta',
  INFO_ON_WORKER = 'infoOnWorker',
  MISSION = 'mission',
  REGISTRATION_NUMBER = 'registrationNumber',
  UNIT = 'unit',
  WORKER = 'worker',
}
